import graphql__ece1f80c786498df32e7 from "./__generated__/CityWalkHomeRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import CityWalkHome from "../CityWalks/CityWalkHome";

const CityWalkHomeRoute = props => {
  const { participativeModuleSlug: participativeModuleSlug } = useParams();

  return (
    <AppQueryRenderer
      key={participativeModuleSlug}
      query={CityWalkHomeRouteQuery}
      variables={{ participativeModuleSlug }}
      component={CityWalkHome}
      additionalProps={props}
      // Ensure that the contribution object is always reloaded from the server when the
      // route is accessed, to avoid a completed contribution to be used from the store
      // as we want to reset the process when the user completes a contribution and comes
      // back to the home page.
      fetchPolicy="network-only"
    />
  );
};

const CityWalkHomeRouteQuery = graphql__ece1f80c786498df32e7;

export default CityWalkHomeRoute;
